import React from 'react';
import PropTypes from 'prop-types';
import BaseVideoPlayer from "../../Internals/BaseVideoPlayer";
import BaseVideoPlayerWithConnector
  from "../../Internals/BaseVideoPlayerWIthConnector";


const LivePlayer = ({liveId, iframeUrl}) => (
        <BaseVideoPlayer type="live" srcId={liveId}  iframeUrl={iframeUrl}/>
    );

LivePlayer.propTypes = {
    /** Live id */
    liveId : PropTypes.string.isRequired
};

export default LivePlayer;
